import {FC, useCallback, useState} from 'react'
import NewStockRequest from './components/NewStockRequest'
import StockRequestHistory from './components/StockRequestHistory'

const AddToStock: FC = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const handleSubmitted = useCallback(() => setRefreshKey((k) => k + 1), [])

  return (
    <>
      <NewStockRequest onSubmitted={handleSubmitted} />
      <StockRequestHistory refreshKey={refreshKey} />
    </>
  )
}

export default AddToStock
